import type { FamilyMember } from '~/types/app';

export const getDisplayNameFromMemberFamily = (member: FamilyMember) => {
  if (member.firstname) return member.firstname;
  if (member.displayName) return member.displayName;
  if (member.name) return member.name;
  return '';
};
